"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type FeedbackStatusAction = "in_progress" | "resolved";

interface FeedbackStatusConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: FeedbackStatusAction | null;
  feedbackText?: string;
  onConfirm: () => void;
}

export function FeedbackStatusConfirmDialog({
  open,
  onOpenChange,
  action,
  feedbackText,
  onConfirm,
}: FeedbackStatusConfirmDialogProps) {
  const isInProgress = action === "in_progress";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isInProgress
              ? "Take feedback in progress?"
              : "Mark feedback as resolved?"}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <span className="block">
              {isInProgress
                ? "This will mark the feedback as being worked on."
                : "This will mark the feedback as completed and resolved."}
            </span>
            {feedbackText && (
              <span className="block p-3 bg-gray-50 rounded-md text-sm text-gray-700 border">
                "{feedbackText}"
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={
              isInProgress
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-green-600 hover:bg-green-700"
            }
          >
            {isInProgress ? "Take in Progress" : "Mark Resolved"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
